export class ResponseModel {
    id: number;
    isSuccess: boolean;
    message: string;
    content: any
}